import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'
import withData from '../utils/withData'

import {
  Link
} from 'react-router-dom';

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import OpeningTimes from '../components/OpeningTimes'
import CallToAction from '../components/CallToAction'
import Happenings from '../components/Happenings'
import Rates from '../components/Rates'
import LiveGallery from '../components/LiveGallery'
import ContentBlocks from '../components/ContentBlocks'
import MiniMap from '../components/MiniMap'
import Window from '../components/Window'
import ScrollTo from '../components/ScrollTo'
import Tidy from '../components/Tidy'

import Asset from '../models/Asset'
import Entry from '../models/Entry'

require('../helpers/Array.js');

let selection = [];
let views = 0;

class PlanMyDay extends Component {

	constructor(props) {
		super(props);
		this.state = {views:0};
	}

	componentWillMount() {
		if(!views){

			this.goAgain();

		}
	}

	componentWillUnmount() {

	}

	goAgain = () => {

		views++;

		selection = [
								{category:'Morning',time:'10:00AM'},
								{category:'Lunch',time:'12:30PM'},
								{category:'Afternoon',time:'3:00PM'},
								{category:'Dinner',time:'7:00PM'},
								{category:'Night',time:'10:30PM'}

							].map((section, ix) =>
							(<div className={'Template-section Template-section--narrow ' + (((ix + 1) % 2 == 0) ? 'Template-section--even' : 'Template-section--odd' )}>
								{this.get(section.category.toLowerCase()).shuffle().limit(1).map((item) => 

									(<Item modifiers={['itinerary']}>
										<Link to={item.uri}>
										<div className="Item-media">
											<Media fluid={false} ratio={6/4} id={item.image[0]} />
										</div>
										<div className="Item-body">
											<Content modifier={'itinerary'}>
											<h3>{section.category}</h3>
											<h1>{item.itineraryPhrase}</h1>
											<h2><Tidy html={item.title}/></h2>
											</Content>
										</div>
										<div className="Item-foot">
											<Content modifier={'itinerary'}>
												<p>{section.time}</p>
											</Content>
										</div>
										</Link>
									</Item>)
								
								)}
							</div>)
							)

		this.setState({views:views});

	}

	shouldComponentUpdate = (nextProps,nextState) => {

		return nextState.views != this.state.views;

	}

	nl2br = (str) => {
    	let breakTag = '<br />';
    	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	}

	get = (category) => {

		return this.props.data.entries.filter((item)=> (item.itineraryCategory == category));
		

	}


	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log('entry',entry);

		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className={"Template  Template--default"}>

					

					{/* Template-body */}
					<div className="Template-body">
						<div className="Template-util"><Content modifiers={['util']}><a style={{cursor:'pointer'}} onClick={this.goAgain}>Go Again</a></Content></div>
						<div className="Template-sections">

							{selection}

							{/* Lunch */}
							<div className="Template-section Template-section--narrow">
								
							</div>

							{/* Afternoon */}
							<div className="Template-section Template-section--narrow">
								
							</div>

							{/* Dinner */}
							<div className="Template-section Template-section--narrow">
								
							</div>

							{/* Night */}
							<div className="Template-section Template-section--narrow">
								
							</div>
							
						</div>

					</div>
					{/* / Template-body */}


			</div>
			</FadeIn>
		);

	}
}

export default withData(PlanMyDay);



// WEBPACK FOOTER //
// ./src/js/templates/PlanMyDay.js